<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="row form-page-detail-body-container container-app-search">
    <div
      v-if="!load_first"
      class="d-flex align-items-center justify-content-center"
      style="height: 400px; width: 100%">
      <div class="lds-ellipsis"><div/><div/><div/><div/></div>
    </div>
    <div
      v-if="showTable"
      class="table-column">
      <v-server-table
        v-show="load_first"
        ref="recordTableComponent"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @sorted="sortingColumn">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="openModalData">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-button
              id="filterServerPopover"
              class="btn grey btn-import-form m__r--5">
              <i class="fa fa-filter fa-lg"/> Filter
            </b-button>
            <!-- <b-button
              class="btn grey btn-import-form m__r--5"
              @click="$refs.appImportRecordModal.show(); dropboxImportShow = true">
              <i class="fa fa-cloud-upload fa-lg"/> Import
            </b-button>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="exportData">
              <i class="fa fa-download fa-lg"/> Export
            </b-button> -->
          </b-form>
        </div>

        <div
          v-for="(i, index) in datasetColumn"
          slot-scope="props"
          :key="index"
          :slot="i.name">
          {{ props.row[i.name] }}
          <!-- <b-form-input
            v-if="i.type === 'text' || i.type === 'varchar'"
            v-model="props.row[i.name]"
            class="input-text-cell-table"
            type="text"/>
          <b-form-input
            v-else-if="i.type === 'small_integer' ||
              i.type === 'integer' ||
              i.type === 'big_integer' ||
              i.type === 'float' ||
            i.type === 'decimal'"
            v-model="props.row[i.name]"
            class="input-text-cell-table"
            type="number"/>
          <div
            v-else
            class="input-text-cell-table">{{ props.row[i.name] }}</div> -->
        </div>

        <div
          slot="delete_and_update"
          slot-scope="props">
          <img
            :src="require('@/assets/icon/query/edit.svg')"
            class="cursor-pointer m__r--5"
            width="13"
            @click="openDetail(props.row)">
          <img
            :src="require('@/assets/icon/query/delete.svg')"
            class="cursor-pointer"
            width="13"
            @click="deleteItem(props.row)">
        </div>
      </v-server-table>
    </div>

    <b-popover
      v-if="showTable"
      ref="filterServerPopoverRef"
      :show.sync="popoverFilterServerShow"
      container="form-search-popover"
      target="filterServerPopover"
      placement="top">
      <b-form
        v-click-outside="hideFilter"
        inline
        @keypress.13.prevent="$refs.recordTableComponent.setFilter(filter_data); popoverFilterServerShow = false;">
        <j-single-select
          v-model="select_type"
          :options="options_search"
          :error-required="false"
          placeholder="Filter By"
          label="name"
          class="m__r--5"
          style="width: 200px"/>
        <j-single-select
          v-model="select_option"
          :options="options_filter"
          :error-required="false"
          :clearable="false"
          placeholder="Select"
          value-format="object"
          label="name"
          class="m__r--5"
          style="width: 100px"/>
        <!-- <span
          v-if="cekTypeData(select_type) === 'timestamp'"
          class="reimb-select-period m__r--5">
          <j-datepicker
            v-model="filter_data_start_date"
            :error-required="false"
            placeholder="Start Date"
            format="MMM dd, yyyy"
            class="m__r--5"/>
          <j-datepicker
            v-model="filter_data_end_date"
            :disabled-dates="disableDates(filter_data_start_date)"
            :error-required="false"
            placeholder="End Date"
            format="MMM dd, yyyy"/>
        </span> -->
        <b-form-input
          v-model="filter_data"
          placeholder="Search"
          style="width: 250px !important"/>
      </b-form>
    </b-popover>

    <b-modal
      ref="appAddRecordModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE RECORD</div>
      <j-form-base
        v-if="showRecord"
        ref="jFormCreate"
        :data-fields="dataFields"
        :is-detail="isDetail"/>
      <br>
      <b-row>
        <b-col md="12">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCreateData">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createRecordData">
              Submit
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appEditRecordModal"
      class="mod-form modal-add-record-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">EDIT RECORD</div>
      <b-row>
        <b-col md="7">
          <label> JSON </label>
        </b-col>
        <b-col
          md="3"
          class="p__r--1">
          <small class="pull-right">Dark Mode</small>
        </b-col>
        <b-col
          md="2"
          class="p__l--1">
          <j-toggle v-model="darkMode"/>
        </b-col>
      </b-row>
      <prism-editor
        v-model="jsonData"
        :highlight="highlighter"
        :line-numbers="true"
        :class="{'dark-mode' : darkMode}"
        class="my-editor"
      />
      <br>
      <b-row>
        <b-col md="4">
          <b-button
            class="btn red"
            @click="deleteRecordData">
            Delete
          </b-button>
        </b-col>
        <b-col md="8">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="$refs.appEditRecordModal.hide();">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="updateRecordData">
              Update
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="appImportRecordModal"
      class="mod-form modal-add-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">IMPORT</div>
      <div
        v-if="dropboxImportShow"
        class="dropbox-oos">
        <input
          type="file"
          multiple
          class="input-file"
          @change="handleFileUpload($event.target.files)">
        <img :src="require('@/assets/form-data/file-dropbox.png')">
        <div class="label-dropbox">Drop your file here, or <span>browse</span></div>
        <div class="label-support-dropbox">Support : ZIP</div>
      </div>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeImportForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import jApiJoana from '@/services/jApiJoana';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import Vue from 'vue';
import ClickOutside from 'vue-click-outside';

import jFormBase from '@/components/form-base/jFormBase';

import { highlight, languages } from 'prismjs/components/prism-core';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  // eslint-disable-next-line
  directives: {
    ClickOutside,
  },
  components: {
    PrismEditor,
    jFormBase,
  },
  data() {
    return {
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      popoverFilterServerShow: false,
      select_type: null,
      select_option: {
        id: 'like',
        name: 'Like',
        value: 'where_like_and',
      },
      options_search: [],
      options_filter: [
        {
          id: 'like',
          name: 'Like',
          value: 'where_like_and',
        },
        {
          id: 'is',
          name: 'Is',
          value: 'where_is_and',
        },
      ],
      filter_data: '',
      filter_data_start_date: null,
      filter_data_end_date: null,
      jsonData: '',
      idRecord: '',
      darkMode: false,
      isDetail: false,
      showRecord: false,
      load_first: false,
      dropboxImportShow: false,
      showTable: false,
      columnSort: null,
      dataFields: [],
      data_table: [],
      columns: [],
      datasetColumn: [],
      datasetDetail: null,
      table_options: {
        headings: {},
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        debounce: 1000,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],

        requestAdapter(data) {
          return {
            limit: Number(data.limit),
            page: data.page,
            filter: data.filter,
            filter_operator: data.filter_operator,
            sort: data.sort,
          };
        },
        requestFunction(data) {
          const list = jApiJoana.getListRecordByDatasetId(data);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.count ? data.count : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreJoana', ['form_id', 'dataset_data']),
  },
  watch: {
    // data_table: {
    //   // eslint-disable-next-line
    //   handler: function (val, oldVal) {
    //     console.log(val);
    //     console.log(oldVal);
    //   },
    //   deep: true,
    // },
  },
  created() {
    if (this.dataset_data) {
      this.getDetail();
    }
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreJoana', ['getDetailDatasetByGroup', 'createRecordDataset', 'updateRecordDataset', 'deleteRecordDataset']),

    getDetail() {
      const req = {
        id: this.dataset_data.id,
      };
      this.getDetailDatasetByGroup(req).then((res) => {
        this.load_first = true;
        const dataDetail = res.data || null;
        this.datasetDetail = dataDetail;
        if (dataDetail && dataDetail.column) {
          const columnData = Object.values(dataDetail.column);
          this.datasetColumn = columnData;
          this.definedColumnTable();
        }
      });
    },

    exportData() {
      this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
      const token = Vue.ls.get('Token');
      const gateUrl = localStorage.getItem('gateUrl');
      const url = `${gateUrl}nocode/record/export-zip`;
      const params = {
        form_data_id: this.form_id,
      };

      axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      }).then((res) => {
        this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
        const a = document.createElement('a');
        const urlBlob = window.URL.createObjectURL(res.data);
        const fileName = 'record.zip';

        a.href = urlBlob;
        a.download = fileName;
        a.click();
      });
    },

    handleFileUpload(file) {
      console.log(file);
      if (file[0].type.includes('zip')) {
        this.$swal({
          title: 'IMPORT',
          text: `Are you sure to import file ${file[0].name} ?`,
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then(async (result) => {
          if (result.value) {
            this.$store.dispatch('jStoreNotificationScreen/showLoading', 'Please wait');
            const token = Vue.ls.get('Token');
            const formData = new FormData();
            const gateUrl = localStorage.getItem('gateUrl');
            const url = `${gateUrl}nocode/record/import-zip?form_data_id=${this.form_id}&token=${token}`;

            formData.append('file', file[0]);

            axios.post(url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
            ).then(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Success Import Data');
              this.$refs.recordTableComponent.refresh();
              this.closeImportForm();
            }).catch(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading', '');
              this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Error Import Data');
            });
          } else {
            this.dropboxImportShow = false;
            setTimeout(() => {
              this.dropboxImportShow = true;
            }, 100);
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'File not support');
      }
    },

    closeImportForm() {
      this.$refs.appImportRecordModal.hide();
      this.dropboxImportShow = false;
    },

    disableDates(date) {
      if (date) {
        return {
          to: new Date(date - 8640000),
        };
      }
      return {};
    },

    cekTypeData(key) {
      if (key === '') { return ''; }
      if (key === null) { return ''; }
      const findType = this.datasetDetail.column[key];
      return findType ? findType.type : '';
    },

    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    convertTimestamp(data) {
      const date = new Date(data);
      const years = date.getFullYear();
      const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      return `${years}-${mounth}-${dates}`;
    },

    definedColumnTable() {
      this.datasetColumn.forEach((e) => {
        this.columns.push(e.name);
        this.table_options.headings[e.name] = e.name;
        this.table_options.sortable.push(e.name);
      });
      this.columns.push('delete_and_update');
      this.table_options.headings.delete_and_update = 'action';
      this.showTable = true;

      this.options_search = [];
      this.datasetColumn.forEach((e) => {
        if (e.type !== 'timestamp' && e.type !== 'boolean') {
          this.options_search.push({
            text: e.name,
            name: e.name,
            value: e.name,
            id: e.name,
          });
        }
      });
    },

    loading(val) {
      const a = val;
      const dataFilter = {};

      let x;
      // eslint-disable-next-line
      const _user = this.session.user;

      if ((this.filter_data || (this.filter_data_start_date && this.filter_data_end_date)) && this.select_type) {
        if (this.cekTypeData(this.select_type) === 'timestamp') {
          const startDate = this.$moment(this.filter_data_start_date).format('YYYY-MM-DD');
          const endDate = this.$moment(this.filter_data_end_date).format('YYYY-MM-DD');
          const startOfDay = new Date(Date.parse(`${startDate} 00:00:00`)).getTime();
          const endOfDay = new Date(Date.parse(`${endDate} 23:59:59`)).getTime();
          // eslint-disable-next-line
          dataFilter[this.select_type] = { '$between': [startOfDay, endOfDay] };
        } else {
          // eslint-disable-next-line
          if (this.cekTypeData(this.select_type) === 'small_integer' ||
            this.cekTypeData(this.select_type) === 'integer' ||
            this.cekTypeData(this.select_type) === 'big_integer' ||
            this.cekTypeData(this.select_type) === 'float' ||
            this.cekTypeData(this.select_type) === 'decimal') {
            dataFilter[this.select_type] = Number(this.filter_data);
          } else {
            dataFilter[this.select_type] = this.filter_data;
          }
        }
      }

      a.dataset_id = this.dataset_data.id;
      a.filter = { [this.select_option.value]: dataFilter };
      a.filter_operator = 'and';
      a.sort = this.columnSort || {};

      if (this.load_first) {
        this.showLoading();
      }
    },
    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeCreateData() {
      this.$refs.appAddRecordModal.hide();
      this.showRecord = false;
    },

    createRecordData() {
      this.$refs.jFormCreate.getData().then((params) => {
        const data = {
          dataset_id: this.dataset_data.id,
          data: {},
        };
        this.datasetColumn.forEach((e) => {
          const findValue = params.find(f => f.name === e.name);
          if (this.getTypeField(e.type) === 'number' || this.getTypeField(e.type) === 'number_decimal') {
            data.data[e.name] = findValue.value ? Number(findValue.value) : 0;
          } else if (this.getTypeField(e.type) === 'date_time') {
            data.data[e.name] = findValue.value || 0;
          } else {
            data.data[e.name] = findValue.value || null;
          }
        });
        // eslint-disable-next-line
        this.createRecordDataset(data).then((response) => {
          this.$refs.recordTableComponent.refresh();
        });
      });
      this.$refs.appAddRecordModal.hide();
      this.showRecord = false;
    },

    updateRecordData() {
      const data = {
        dataset_id: this.dataset_data.id,
        data: JSON.parse(this.jsonData),
      };

      this.updateRecordDataset(data).then((response) => {
        this.$refs.recordTableComponent.refresh();
        this.$refs.appEditRecordModal.hide();
      });
    },

    openModalData() {
      this.dataFields = [];
      this.datasetColumn.forEach((el) => {
        this.dataFields.push(
          {
            id: Number(`${Math.floor(Math.random() * 100)}${Math.floor(Math.random() * 100)}`),
            name: el.name,
            type: this.getTypeField(el.type),
            placeholder: '',
            grid: '12',
            is_delete: el.name === this.datasetDetail.primary_key,
            is_editable: false,
            is_hidden: false,
            is_mandatory: false,
            field_key: null,
            field_ui_key: el.name,
            field_data_key: el.name,
          },
        );
      });
      this.$refs.appAddRecordModal.show();
      this.showRecord = true;
    },

    getTypeField(type) {
      if (type === 'timestamp') {
        return 'date_time';
      } else if (type === 'small_integer' || type === 'integer' || type === 'big_integer') {
        return 'number';
      } else if (type === 'float' || type === 'decimal') {
        return 'number_decimal';
      } else if (type === 'boolean') {
        return 'toggle';
      } else if (type === 'text') {
        return 'descriptive';
      }
      return 'text';
    },

    openDetail(data) {
      this.idRecord = data[this.datasetDetail.primary_key];
      this.jsonData = JSON.stringify(data, null, 4);
      this.$refs.appEditRecordModal.show();
    },

    deleteItem(data) {
      this.$swal({
        title: 'Delete Record',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const params = {
            id: data[this.datasetDetail.primary_key],
            dataset_id: this.dataset_data.id,
          };
          // eslint-disable-next-line
          this.deleteRecordDataset(params).then((response) => {
            this.$refs.recordTableComponent.refresh();
          });
        }
      });
    },

    deleteRecordData() {
      this.$swal({
        title: 'Delete Record',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const params = {
            id: this.idRecord,
            dataset_id: this.dataset_data.id,
          };
          // eslint-disable-next-line
          this.deleteRecordDataset(params).then((response) => {
            this.$refs.recordTableComponent.refresh();
            this.$refs.appEditRecordModal.hide();
          });
        }
      });
    },

    sortingColumn(val) {
      const { column, ascending } = val;
      this.columnSort = {
        [column]: ascending ? 1 : -1,
      };
    },

    hideFilter() {
      this.popoverFilterServerShow = false;
    },
  },
  validations() {
    return {
    };
  },
};
</script>

<style lang="scss">
  .input-text-cell-table {
    border: 0px;
    background-color: transparent;
    color: #848689;
    font-size: 12px;
    min-width: 125px;
  }

  .form-page-detail-body-container {
    // background-color: #ffffff;
    overflow: auto;
    margin: 1px;
    // height: 100%;
  }

  .table-column .jTable {
    width: 95%;
    margin-left: 15px;
  }

  .modal-add-record-data .modal-dialog {
    max-width: 800px !important;
  }

  @media only screen and (max-height: 855px) {
    .table-column {
      // max-height: 550px;
      width: 100%;
    }
  }
  @media only screen and (min-height: 856px) {
    .table-column {
      // max-height: 650px;
      width: 100%;
    }
  }

  .my-editor {
    font-family: 'Poppins-Regular';
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
    border: 1px solid #D8D8D8;
  }

  .dark-mode {
    background: #2d2d2d;
  }

  .dark-mode .prism-editor__editor {
    color: #ccc !important;
  }

  .prism-editor__textarea:focus {
    outline: none;
  }

  .prism-editor__editor span{
    font-size: inherit !important;
  }

  .prism-editor__editor {
    color: #5c5b5b;
  }

  .jTable .VuePagination {
    margin-top: 15px;
  }

  .jSelectSingle.vue-treeselect .vue-treeselect__menu-container .vue-treeselect__menu .vue-treeselect__list .vue-treeselect__list-item .vue-treeselect__option .vue-treeselect__label-container .vue-treeselect__label {
    text-align: left !important;
    float: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetData.vue